module.exports = __webpack_public_path__ + "img/facts-all_1929.9f1135d7.png";